export default "/images/divide-circle.svg?07377dfaccaa3671f2160996ce387d47";